// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"a0b46c59","87":"a12211e4","283":"828e5c97","310":"1761e9e1","313":"c8c159a2","394":"11426246","449":"91f3693f","585":"18435802","586":"8d959e65","618":"1ec84512","698":"d037a830","828":"1a85e828"}[chunkId] + ".chunk.js";
};